import { withStyles } from '@material-ui/core';

import DotIndicator from './component';
import styles from './styles';

export default withStyles(styles)(DotIndicator);
